import React from 'react'
import PropTypes from 'prop-types'
import TextareaAutosize from 'react-textarea-autosize'

import './style.css'

const TextInput = ({
  label,
  description,
  inputType,
  inputClass,
  value,
  inputChange,
  name,
  placeholder,
  disabled,
  onKeyPress,
  useTextArea,
  id,
  autoFocus,
  ref,
  required,
  showError,
  errorMessage,
  onFocus,
  onBlur,
  min,
  max,
  onPaste,
  tabIndex,
  spellCheck,
  onKeyUp,
}) => {
  return (
    <div className="textinput-container">
      {label && (
        <label className="textinput-label">
          {label}
          <div className="textinput-description">{description}</div>
        </label>
      )}
      {!useTextArea && (
        <input
          required={required}
          ref={ref}
          className={`custom-input clr-black ${inputClass}`}
          type={inputType}
          value={value || ''}
          placeholder={placeholder}
          onChange={e => inputChange(e, name)}
          disabled={disabled}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          id={id}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onBlur={onBlur}
          min={min}
          max={max}
          onPaste={onPaste}
          tabIndex={tabIndex}
          spellCheck={spellCheck}
        />
      )}
      {useTextArea && (
        <TextareaAutosize
          required={required}
          inputRef={ref}
          className={`custom-input clr-black ${inputClass}`}
          type={inputType}
          value={value || ''}
          placeholder={placeholder}
          onChange={e => inputChange(e, name)}
          disabled={disabled}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          minRows={min ? min : 1}
          maxRows={max}
          id={id}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onBlur={onBlur}
          onPaste={onPaste}
          tabIndex={tabIndex}
          spellCheck={spellCheck}
        />
      )}
      {showError && <div className="textinput-error">{errorMessage}</div>}
    </div>
  )
}

TextInput.propTypes = {
  label: PropTypes.string,
  inputType: PropTypes.string.isRequired,
  inputClass: PropTypes.string,
  value: PropTypes.string,
  inputChange: PropTypes.func,
  name: PropTypes.string,
  placeholder: PropTypes.string,
}

TextInput.defaultProps = {
  inputClass: '',
  value: '',
}

export default TextInput
